export default "App Configuration"